import {useContext, useState} from 'react';
import SpotifyApiContext from '../../spotify/spotifyApiContext';
import {artistsStoreSlice} from '../../redux/artists/artists.slice';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {useAppDispatch} from '../../redux/store';

function useUnfollowArtist(): [(id: string) => Promise<void>, boolean] {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const api = useContext(SpotifyApiContext);
  const dispatch = useAppDispatch();
  const unfollowArtist = (artistId: string) => {
    setIsLoading(true);

    return api
      .unfollowArtists([artistId])
      .then(() => {
        dispatch(artistsStoreSlice.actions.removeFollowedArtistIds([artistId]));

        toast(t('ArtistMenu.UnfollowToast'), {
          type: 'success',
          position: 'top-center'
        });
      })
      .catch(() => {
        toast(t('ArtistMenu.UnfollowToastErr'), {
          type: 'error',
          position: 'top-center'
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return [unfollowArtist, isLoading];
}

export default useUnfollowArtist;
